import * as React from "react";
import CenteredPageContainer from "components/Layout/CenteredPageContainer";
import CustomerBolOverview from "components/CustomerBolOverview";
import { ColLayout } from "./CustomerBolPage.Style";
import { Row } from "antd";

export interface Props {
    children?: React.ReactNode
}

export interface State {
}

export default class CustomerBolPage extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <CenteredPageContainer title="Customer Bol" size={ColLayout}>
                <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px 65px", marginTop: "5px" }}>
                    <CustomerBolOverview />
                </Row>
            </CenteredPageContainer>
        )
    }
}
